import { ISectionFilters, ISectionLabelValue } from '../../../interfaces/scheduler_interfaces';
import { SectionFiltersModel } from '../models/section_filters_model';
import { ORMMediator } from 'utility-ts-orm';
import * as _4 from 'lodash4';
import { SelectedSectionFiltersModel } from '../models/selected_section_filters_model';

export class SectionFiltersQuery {
  private _result: {
    instructors: Array<{ title: string; value: string }>;
    section_labels: ISectionLabelValue[];
    selectedFiltersCount: number;
    selectedInstructors: string[];
  };
  constructor(
    private ngSectionFiltersModel: SectionFiltersModel,
    private ngSelectedSectionFiltersModel: SelectedSectionFiltersModel
  ) {
    ORMMediator.registerQuery(this, ngSectionFiltersModel, ngSelectedSectionFiltersModel);
  }
  run() {
    const selectedInstructors = this.ngSelectedSectionFiltersModel.read().instructors;
    const selectedSectionLabels = this.ngSelectedSectionFiltersModel.read().section_labels;
    const selectedFiltersCount = selectedInstructors.length + selectedSectionLabels.length;

    const instructors = _4.map(this.ngSectionFiltersModel.read().instructors, (instructor: string) => {
      return {
        title: instructor,
        value: instructor
      };
    });
    const section_labels = _4.map(
      this.ngSectionFiltersModel.read().section_labels,
      (sectionLabel: ISectionLabelValue) => {
        const checked = !_4.isEmpty(_4.find(selectedSectionLabels, { value: sectionLabel.value }));
        return {
          desc: sectionLabel.desc,
          id: sectionLabel.id,
          value: sectionLabel.value,
          checked
        };
      }
    );
    this._result = {
      instructors,
      section_labels,
      selectedInstructors,
      selectedFiltersCount
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngSectionFiltersQuery', SectionFiltersQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_filters/queries/section_filters_query.ts